import { render, staticRenderFns } from "./dui-option-search.vue?vue&type=template&id=2bb37499&scoped=true&"
import script from "./dui-option-search.vue?vue&type=script&lang=js&"
export * from "./dui-option-search.vue?vue&type=script&lang=js&"
import style0 from "./dui-option-search.vue?vue&type=style&index=0&id=2bb37499&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb37499",
  null
  
)

export default component.exports